<div id="rechtliches">
  <vertrag-kuendigen *ngIf="rechts_txt === 'kuendigung'"></vertrag-kuendigen>
  <kontakt *ngIf="rechts_txt === 'kontakt'"></kontakt>
  <mat-card id="rechtlichesContent" class="contentblock" *ngIf="localContent" [innerHTML]="localContent"></mat-card>
</div>

